import React from 'react';
import './Footer.css';

const Footer = () => {
  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-logo-section">
            <a href="#home" className="footer-logo-link" onClick={(e) => handleSmoothScroll(e, 'home')}>
              <img src="/i.jpg" alt="Tara Medicos logo" className="footer-logo-icon" />
              <h3 className="footer-title">TARA MEDICOS PVT LTD.</h3>
            </a>
            <p className="footer-description">
              Six decades of trust in pharmaceutical distribution. Delivering quality healthcare solutions with reliability and ethical practices since 1966.
            </p>
            {/* <div className="footer-social">
              <a href="#" className="social-icon">🔵</a>
              <a href="#" className="social-icon">📷</a>
              <a href="#" className="social-icon">💼</a>
            </div> */}
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Navigation</h4>
            <ul className="footer-links">
              <li><a href="#home" onClick={(e) => handleSmoothScroll(e, 'home')}>Home</a></li>
              <li><a href="#about" onClick={(e) => handleSmoothScroll(e, 'about')}>Our Journey</a></li>
              <li><a href="#expertise" onClick={(e) => handleSmoothScroll(e, 'expertise')}>What We Do</a></li>
              <li><a href="#branches" onClick={(e) => handleSmoothScroll(e, 'branches')}>Our Branches</a></li>
              <li><a href="#partners" onClick={(e) => handleSmoothScroll(e, 'partners')}>Our Principals</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact-info">
              <p>📍 A-7, Bais Godam Main Road, Jaipur</p>
              <p>📞 0141 3100030</p>
              <p>📧 info@taramed.net</p>
              <p>🕒 Mon-Sat: 08:00 - 20:00</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} TARA MEDICOS PVT LTD. All rights reserved.
            </p>
            <div className="footer-meta-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
